module.exports = {"id":"236007","name":"Ezequiel Barco","rating":"74","photo":"./data/images/photos/3/236007.png","club":{"name":"Atlanta United FC","logo":"./data/images/clubs/AtlantaUnitedFC.png"},"positions":["MG","MC","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EzequielBarco0.json
// module id = 1316
// module chunks = 0